module.exports = __webpack_public_path__ + "img/radar-chart.483f59b6.svg";